import { IonCol, IonLabel, isPlatform } from "@ionic/react";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import {
  // getNotifications,
  updateNotificationStatus,
  clearAllNotifications,
} from "../../../Store/Actions";
import NotificationsBanner from "../../../utils/NotificationsBanner";
import ScreenBanner from "../../../utils/screenBanner";
import PageHeading from "../../CustomComponents/PageHeading";
import "../../Portal/Notifications/Notifications.scss";

export interface NotificationProps {
  isWeb: boolean;
  updatePopOver: Function;
}

export const Notifications: React.FC<NotificationProps> = (props: any) => {
  React.useEffect(() => {
    // props.getNotifications();
  }, []);
  return (
    <IonCol className="middle_panle res_bg_color notification-box">
      {isPlatform("ios") && <div className="ios_statusbar_color" />}
      <div className="notification-main">
        <PageHeading
          mainHeader="Notifications"
          navigation={props}
          showCars={false}
          isWeb={props.isWeb}
          updatePopOver={props.updatePopOver}
          showCart={false}
          cssClass={"notification-page-heading"}
        />
      </div>
      <div
        className={
          isPlatform("ios")
            ? "noti_container notification-web noti_marginTop90"
            : "noti_container notification-web"
        }
      >
        {!!props.userNotifications.length ? (
          props.userNotifications.map((notification: any, ind: any) => (
            <div
              className="noti_box"
              key={ind}
              onClick={() => {
                if (props.isWeb) {
                  props.updatePopOver();
                }
                !notification.isRead &&
                  props.updateNotificationStatus(notification.id, {
                    id: notification.id,
                    isRead: !notification.isRead,
                  });
                props.history.push({
                  pathname: "/portal/booking_details",
                  state: {
                    idOfBooking: notification.bookingId,
                  },
                });
              }}
            >
              <IonLabel className="noti_time">
                {moment(new Date(notification.createdAt.seconds * 1000)).format("hh:mm A")}
              </IonLabel>
              <div className="noti_heading_container">
                <img
                  src={notification.type === "WARN" ? "/images/Warn.svg" : ""}
                  className="noti_status_img"
                />
                <IonLabel className="noti_heading">Garage Allowed</IonLabel>
              </div>
              <IonLabel
                className="noti_desc"
                style={{
                  fontWeight: notification.isRead ? "normal" : "bold",
                  color: notification.isRead ? "" : "black",
                }}
              >
                {notification.description.charAt(0).toUpperCase() +
                  notification.description.slice(1)}
                {". "}
                Please Click here to view the Garage details or visit your bookings page
              </IonLabel>
            </div>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <NotificationsBanner />
          </div>
        )}
      </div>
      {!!(props.userNotifications || []).length && (
        <div
          className="clear_notifications"
          onClick={() => {
            props.clearAllNotifications();
          }}
        >
          <IonLabel className="clearall_text">Clear All</IonLabel>
          <img src="/images/clear_notifications.svg" className="clear_noti_icon" />
        </div>
      )}
    </IonCol>
  );
};
export default connect(({ notification }: any) => ({ ...notification }), {
  // getNotifications,
  updateNotificationStatus,
  clearAllNotifications,
})(Notifications);
